import { applyDependencyPatches } from "vxrn";
function fixDependenciesPlugin(options) {
  var patches = [];
  for (var key in options) {
    var value = options[key];
    if (value && typeof value === "object") {
      patches.push({
        module: key,
        patchFiles: value
      });
    }
  }
  return {
    name: "one-fix-dependencies",
    enforce: "pre",
    async configResolved(config) {
      await applyDependencyPatches(patches, config);
    }
  };
}
export {
  fixDependenciesPlugin
};
//# sourceMappingURL=fixDependenciesPlugin.js.map
